import cardBrand from './../../constants/card-brand.constants'
import { createActions, createReducer } from 'reduxsauce'

export const { Types, Creators } = createActions(
	{
		setCardBrand: ['cardBrand'],
		setInstallmentsQtt: ['installmentsQtt'],
		setCreditCardNumber: ['creditCardNumber'],
		setInstallmentsOptions: ['installmentsOptions'],
		setInterestRate: ['installments'],
	},
	{
		prefix: 'credit-card-purchase/',
	}
)

const initialState = {
	installmentsQtt: 1,
	cardBrand: cardBrand.visa,
	creditCardNumber: '0000000000000000',
	installmentsOptions: [],
	interestRate: 0,
}

const setInstallmentsQtt = (state = initialState, { installmentsQtt }) => ({
	...state,
	installmentsQtt,
})

const setInterestRate = (state = initialState, { installments }) => {
	const { interest } = state.installmentsOptions[installments - 1]
	return { ...state, interestRate: interest }
}

const setCreditCardNumber = (state = initialState, { creditCardNumber }) => ({
	...state,
	creditCardNumber,
})

const setCardBrand = (state = initialState, { cardBrand }) => ({
	...state,
	cardBrand,
})

const setInstallmentsOptions = (
	state = initialState,
	{ installmentsOptions }
) => ({
	...state,
	installmentsOptions,
})

export default createReducer(initialState, {
	[Types.SET_CARD_BRAND]: setCardBrand,
	[Types.SET_INSTALLMENTS_QTT]: setInstallmentsQtt,
	[Types.SET_CREDIT_CARD_NUMBER]: setCreditCardNumber,
	[Types.SET_INSTALLMENTS_OPTIONS]: setInstallmentsOptions,
	[Types.SET_INTEREST_RATE]: setInterestRate,
})
